export enum eStorageFolder {
  BIllToPay = 1,
  Contracts = 2,
  Documents = 3,
  Facial = 4,
  General = 5,
  HelpDeskTickets = 6,
  HotsiteBackgrounds = 7,
  HotsiteCards = 9,
  Licenses = 11,
  Logos = 12,
  NFSes = 13,
  TreinoExercises = 14,
  TreinoPosts = 15,
  UserPhotos = 16,
  HotsiteBackgroundsSubscriptions = 17,
  Financial = 18,
  Chat = 19,
  CertificateArchive = 20,
  Goods = 21,
  CrmAutomations = 22,
  AccesAdvertisement = 23,
}

export enum StorageObjectStatus {
  Temporary = 0,
  Confirmed = 1,
}